(function () {
  'use strict';

  const q = (selector, scope = document) => scope.querySelector(selector);
  const qa = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  function initHeader() {
    const header = q('[data-dn-header]');
    if (!header || header.dataset.dnReady === 'true') return;
    header.dataset.dnReady = 'true';

    const triggers = qa('[data-dn-open]', header);
    const overlays = qa('[data-dn-overlay]', header);
    let activeOverlay = null;
    let activeTrigger = null;

    const closeOverlay = () => {
      if (!activeOverlay) return;
      activeOverlay.classList.remove('is-open');
      activeOverlay.setAttribute('aria-hidden', 'true');
      triggers.forEach((trigger) => trigger.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('dn-overlay-open');
      if (activeTrigger) activeTrigger.focus();
      activeOverlay = null;
      activeTrigger = null;
    };

    const openOverlay = (name, trigger) => {
      const overlay = q(`[data-dn-overlay="${name}"]`, header);
      if (!overlay) return;
      closeOverlay();
      activeOverlay = overlay;
      activeTrigger = trigger;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.classList.add('dn-overlay-open');
      const focusTarget = q('input, a, button', overlay);
      if (focusTarget) window.setTimeout(() => focusTarget.focus(), 90);
    };

    triggers.forEach((trigger) => {
      trigger.addEventListener('click', () => openOverlay(trigger.dataset.dnOpen, trigger));
    });
    qa('[data-dn-close]', header).forEach((button) => button.addEventListener('click', closeOverlay));
    overlays.forEach((overlay) => {
      overlay.addEventListener('click', (event) => {
        if (event.target === overlay) closeOverlay();
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeOverlay();
    });

    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 12);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  function initReveal(scope = document) {
    const elements = qa('.dn-reveal:not([data-dn-reveal-ready])', scope);
    if (!elements.length) return;
    elements.forEach((element) => { element.dataset.dnRevealReady = 'true'; });

    if (!('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -3% 0px' });

    elements.forEach((element) => observer.observe(element));
  }

  function initDelivery(scope = document) {
    qa('[data-dn-date-offset]', scope).forEach((element) => {
      if (element.dataset.dnReady === 'true') return;
      element.dataset.dnReady = 'true';
      const startOffset = Number(element.dataset.dnDateOffset || 0);
      const endOffset = Number(element.dataset.dnDateEnd || startOffset);
      const format = (offset) => {
        const date = new Date();
        date.setDate(date.getDate() + offset);
        return new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: '2-digit' }).format(date);
      };
      element.textContent = startOffset === endOffset
        ? format(startOffset)
        : `${format(startOffset)} – ${format(endOffset)}`;
    });
  }

  function initFitFinder(scope = document) {
    qa('[data-dn-fit]', scope).forEach((finder) => {
      if (finder.dataset.dnReady === 'true') return;
      finder.dataset.dnReady = 'true';

      const modal = q('[data-dn-fit-modal]', finder);
      const open = q('[data-dn-fit-open]', finder);
      const closeButtons = qa('[data-dn-fit-close]', finder);
      const height = q('[data-dn-fit-height]', finder);
      const weight = q('[data-dn-fit-weight]', finder);
      const fitButtons = qa('[data-dn-fit-choice]', finder);
      const result = q('[data-dn-fit-result]', finder);
      let fit = 'regular';

      const updateResult = () => {
        if (!height || !weight || !result) return;
        const heightValue = Number(height.value || 0);
        const weightValue = Number(weight.value || 0);
        if (!heightValue || !weightValue) {
          result.innerHTML = '<span>EMPFEHLUNG</span><strong>GRÖSSE WÄHLEN</strong>';
          return;
        }
        const sizes = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];
        let index = heightValue <= 160 ? 0 : heightValue <= 168 ? 1 : heightValue <= 178 ? 2 : heightValue <= 188 ? 3 : heightValue <= 196 ? 4 : 5;
        if (weightValue >= 101) index = Math.max(index, 4);
        else if (weightValue >= 84) index = Math.max(index, 3);
        else if (weightValue >= 69) index = Math.max(index, 2);
        else if (weightValue <= 55) index = Math.min(index, 1);
        if (fit === 'loose') index = Math.min(index + 1, sizes.length - 1);
        result.innerHTML = `<span>UNSERE EMPFEHLUNG</span><strong>${sizes[index]}</strong>`;
      };

      const close = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('dn-modal-open');
        if (open) open.focus();
      };

      if (open && modal) {
        open.addEventListener('click', () => {
          modal.classList.add('is-open');
          modal.setAttribute('aria-hidden', 'false');
          document.body.classList.add('dn-modal-open');
          if (height) window.setTimeout(() => height.focus(), 80);
        });
      }
      closeButtons.forEach((button) => button.addEventListener('click', close));
      if (modal) modal.addEventListener('click', (event) => { if (event.target === modal) close(); });
      if (height) height.addEventListener('change', updateResult);
      if (weight) weight.addEventListener('change', updateResult);
      fitButtons.forEach((button) => {
        button.addEventListener('click', () => {
          fit = button.dataset.dnFitChoice;
          fitButtons.forEach((choice) => choice.setAttribute('aria-pressed', String(choice === button)));
          updateResult();
        });
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal && modal.classList.contains('is-open')) close();
      });
    });
  }

  function initCatalog(scope = document) {
    qa('[data-dn-catalog]', scope).forEach((catalog) => {
      if (catalog.dataset.dnReady === 'true') return;
      catalog.dataset.dnReady = 'true';

      const leaves = qa('[data-dn-catalog-leaf]', catalog);
      const previous = q('[data-dn-catalog-prev]', catalog);
      const next = q('[data-dn-catalog-next]', catalog);
      const status = q('[data-dn-catalog-page]', catalog);
      if (!leaves.length || !previous || !next) return;
      let current = 0;

      const isMobile = () => window.matchMedia('(max-width: 749px)').matches;

      const render = () => {
        if (isMobile()) {
          current = Math.max(0, Math.min(current, leaves.length - 1));
          leaves.forEach((leaf, index) => {
            leaf.classList.remove('is-turned');
            leaf.classList.toggle('is-current', index === current);
          });
          previous.disabled = current === 0;
          next.disabled = current === leaves.length - 1;
          if (status) status.textContent = `${String(current + 1).padStart(2, '0')} / ${String(leaves.length).padStart(2, '0')}`;
          return;
        }

        current = Math.max(0, Math.min(current, leaves.length - 1));
        leaves.forEach((leaf, index) => {
          leaf.classList.remove('is-current');
          leaf.classList.toggle('is-turned', index < current);
        });
        previous.disabled = current === 0;
        next.disabled = current === leaves.length - 1;
        if (status) status.textContent = `${String(current + 1).padStart(2, '0')} / ${String(leaves.length).padStart(2, '0')}`;
      };

      previous.addEventListener('click', () => { current -= 1; render(); });
      next.addEventListener('click', () => { current += 1; render(); });
      window.addEventListener('resize', render, { passive: true });
      render();
    });
  }

  function initAll(scope = document) {
    initHeader();
    initReveal(scope);
    initDelivery(scope);
    initFitFinder(scope);
    initCatalog(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
